<template>
  <a-layout class="auth-layout">
    <a-layout-content class="content-container">
      <div class="logo">
        <template v-if="isThirdPart">
          <img :src="logo" class="logo-img" />
          <span class="site-name">{{ brand }}</span>
          <span class="split" />
        </template>

        <a href="https://matpool.com">
          <img src="@/assets/images/auth/logo.svg" class="logo-matpool" />
        </a>
      </div>
      <router-view></router-view>
    </a-layout-content>
    <layout-footer :show-info="false" class="auth-footer" />
  </a-layout>
</template>

<script>
import LayoutFooter from './components/layout-footer'
import { isThirdPart } from '@/const'

export default {
  components: { LayoutFooter },
  data() {
    return { isThirdPart }
  },
  computed: {
    logo() {
      return require(process.env.VUE_APP_LOGO)
    },
    brand() {
      return process.env.VUE_APP_BRAND
    }
  }
}
</script>

<style lang="less">
.auth-layout {
  &.ant-layout {
    background: url('~@/assets/images/auth/bg.svg') top center/ auto no-repeat;
    background-color: @primary;
    height: 100%;
    min-height: 876px;
    min-width: @safe-width;
    position: relative;
  }

  .logo {
    padding-top: @spacing-6x;
    font-size: @font-h2;
    font-weight: @font-weight-medium;
    line-height: 26px;
    color: @white;

    .site-name {
      font-size: 34px;
      line-height: 1em;
      padding: 0 10px;
      display: inline-block;
      position: relative;
      top: -4px;
    }
    .split {
      display: inline-block;
      height: 32px;
      width: 2px;
      background: @white;
      margin: 0 28px 0 14px;
      vertical-align: bottom;
    }
    &-img {
      width: 50px;
      height: 50px;
      border-radius: 50%;
      vertical-align: bottom;
    }
    &-matpool {
      height: 44px;
      vertical-align: bottom;
    }
  }

  .content-container {
    width: @safe-width;
    margin: auto;
    padding: @spacing-4x 0;
  }

  .auth-footer {
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    background: transparent;

    .copyright {
      height: 32px;
      font-size: 12px;
      line-height: 18px;
      color: @white;
      span {
        margin: 0 @spacing-4x;
      }
      a {
        color: @white;
      }
    }
  }
}
</style>
